import { AccessRequest } from './access-request';
import { Mimic } from './mimic';

export class Vessel {
    id?: string;
    name: string;
    number: string;
    drawingId: string;
    shipyardId: string;
    numberOps: number;
    numberFcu: number;
    numberOfChannels?: number;
    locked: boolean;
    createdBy: string;
    creationDate: string;
    templateVessel?: string;
    templateShipyard?: string;
    templateVersion?: string;
    projectVersion?: string;
    ownerOid?: string;
    ownerName?: string;
    iAPIVesselId?: string;
    projectStatus: ProjectStatus;
    versionStartDate?: Date;
    VesselAccessRequests?: AccessRequest[];
    Mimics?: Mimic[];
}

export interface VesselSimplified {
    id?: string;
    name: string;
    number: string;
    drawingId: string;
    shipyardId: string;
    numberOps: number;
    numberFcu: number;
    iAPIVesselId: string;
    createdBy: string;
    projectVersion: string;
    ownerOid: string;
    ownerName: string;
}

export function getSimplifiedData(vessel: Vessel): VesselSimplified {
    return {
        id: vessel.id,
        name: vessel.name,
        number: vessel.number,
        drawingId: vessel.drawingId,
        shipyardId: vessel.shipyardId,
        numberOps: vessel.numberOps,
        numberFcu: vessel.numberFcu,
        iAPIVesselId: vessel.iAPIVesselId,
        createdBy: vessel.createdBy,
        projectVersion: vessel.projectVersion,
        ownerOid: vessel.ownerOid,
        ownerName: vessel.ownerName,
    };
}

export class VesselBlobData extends Vessel {
    shipyardName: string;
    iAPIShipyardId: string;
}

export enum ProjectStatus {
    undefined = 'Undefined',
    Editing = 'editing',
    PendingApproval = 'pending-approval',
    Approved = 'approved',
    Rejected = 'rejected',
}
